package models

import kotlinx.serialization.Serializable

@Serializable
data class OrganizationModel(
    val id: Int,
    val name: String,
    val sait: String,
    val note: String,
    val userName: String,
    val isactive: Boolean
)
